<template>
  <GroupsModalEditView
    ref="status-permissions-modal-edit-view"
    :groups="groups"
    :value="value"
    :valueEditOrView="valueViewOrEdit"
    :name="id"
    :loading="loading"
    :disabled="disabled"
    @input="setSelectedGroups"
    @cancel="onCancel"
    @onSubmit="onSubmit"
  />
</template>

<script>
import GroupsModalEditView from "@shared/components/packages-form-edit-table/components/GroupsModelEditView.vue";
import { getPermissionGroupsIdList } from "./utils.js"

export default {
  components: {
    GroupsModalEditView,
  },
  props: {
    // need to render different modals properly
    id: {
      type: String,
      required: true,
    },
    groups: {
      type: Object,
      default: () => ({
        client: [],
        tenant: [],
      }),
    },
    selected: {
      type: Array,
      default: () => [],
    },
    selectedViewOrEdit: {
      type: Array,
      default: () => [],
    },
    defaultAll: {
      type: Boolean,
      default: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      // current temp selected:
      value: [],
      valueViewOrEdit: [],
    };
  },

  computed: {
    defaultGroupIds() {
      if (!this.defaultAll) return [];
      return getPermissionGroupsIdList(this.groups);
    },
    defaultGroupIdsViewOrEdit() {
      if (!this.defaultAll) return [];
      return getPermissionGroupsIdList(this.groups, {
        modifier: (el) => ({
          id: el.id || el.group_id,
          read: el.read,
          write: el.write,
        }),
      });
    },
  },

  created() {
    this.setValue();
    this.setValueEditOrView();
  },

  watch: {
    selected(val) {
      this.setValue(val);
    },
    selectedViewOrEdit(val) {
      this.setValueEditOrView(val);
    },
  },

  methods: {
    showModal() {
      this.$refs["status-permissions-modal-edit-view"]?.showModal();
      this.initValues();
    },
    hideModal() {
      this.$refs["status-permissions-modal-edit-view"]?.hideModal();
    },
    setValue(payload = this.selected) {
      this.value = [...payload];
    },
    setValueEditOrView(payload = this.selectedViewOrEdit) {
      this.valueViewOrEdit = [...payload];
    },
    initValues() {
      if (!this.selected.length) this.setValue(this.defaultGroupIds);
      if (!this.selectedViewOrEdit.length)
        this.setValueEditOrView(this.defaultGroupIds);
    },
    onCancel() {
      // reset selected items:
      this.setValue();
      this.setValueEditOrView();
    },
    // onSubmit() {
    //   // reset selected items:
    //   this.$emit("submit", this.value);
    // },
    onSubmit() {
      // Emit both selection arrays for parent to handle as needed
      this.$emit("submit", {
        ids: this.value,
        viewOrEdit: this.valueViewOrEdit,
      });
    },
    /**
     * Handles the input event from the GroupsModalEditView component.
     * Updates the valueViewOrEdit array based on the event data.
     * Supports both single objects and arrays of objects or IDs.
     * @param {Array|Object|string|number} event - The event data from the modal.
     */
    setSelectedGroups(event) {
      console.log("event", event);
      // If event is an array of { id, read, write } objects
      if (
        Array.isArray(event) &&
        event.length > 0 &&
        typeof event[0] === "object" &&
        "read" in event[0] &&
        "write" in event[0]
      ) {
        // Update only those objects in valueViewOrEdit whose ids are in event
        const updated = this.valueViewOrEdit.map((obj) => {
          const found = event.find((e) => e.id === obj.id);
          return found ? { ...obj, ...found } : obj;
        });
        // Add any new objects from event that aren't already in valueViewOrEdit
        event.forEach((e) => {
          if (!updated.some((obj) => obj.id === e.id)) {
            updated.push(e);
          }
        });
        this.valueViewOrEdit = updated;
        return;
      }

      // If event is an array of IDs
      if (Array.isArray(event)) {
        this.value = event;
        return;
      }

      // If event is a single { id, read, write } object
      if (
        typeof event === "object" &&
        event !== null &&
        "id" in event &&
        ("read" in event || "write" in event)
      ) {
        const idx = this.valueViewOrEdit.findIndex((obj) => obj.id === event.id);
        if (idx !== -1) {
          this.valueViewOrEdit.splice(idx, 1, {
            ...this.valueViewOrEdit[idx],
            ...event,
          });
        } else {
          this.valueViewOrEdit.push(event);
        }
        return;
      }

      // If event is a single ID
      if (typeof event === "string" || typeof event === "number") {
        this.value = [event];
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
